import {
  type CheckoutContextProps,
  usePaywallCheckoutContext,
} from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { ConfirmAndDeclineButton } from "@/react/components/Paywalls/CheckoutWithSession/pages/OfferPage/ConfirmAndDeclineButton";
import { ErrorAlert } from "@/react/components/Paywalls/CheckoutWithSession/pages/OfferPage/ErrorAlert";
import { useOfferPageContext } from "@/react/components/Paywalls/CheckoutWithSession/pages/OfferPage/OfferPageProvider";

import { DescriptionContainer } from "../../../../CheckoutWithSession/pages/OfferPage/components/DescriptionContainer";
import { PaywallCustomization } from "../PaywallCustomization";
import { useDetailedOfferContent } from "../PaywallCustomization/Detailed/useDetailedOfferContent";
import { PriceSelectorLine } from "../PriceSelectorModal/PriceSelectorLine";

type CommonData = "paywall";
type PriceSelectorData =
  | "previewMutation"
  | "setSelectedPrice"
  | "isSelectedPrice"
  | "getSelectedPrice"
  | "couponPreviewMutation";

interface OfferProps {
  artificialPadding?: string;
  className?: string;
  useHooks?: () => Pick<CheckoutContextProps, CommonData | PriceSelectorData>;
}

export const Offer = Object.assign(
  ({
    className,
    useHooks = usePaywallCheckoutContext,
    artificialPadding,
  }: OfferProps) => {
    const { paywall } = useHooks();
    const { isPreviewing } = useOfferPageContext();
    const content = useDetailedOfferContent(paywall, { isPreviewing });

    return (
      <div className={classNames("flex flex-col w-full", className)}>
        <PaywallCustomization.Detailed.OfferTemplate
          className={artificialPadding}
          content={content}
          errorAlert={<ErrorAlert />}
          useHooks={useHooks}
        />
        <PaywallCustomization.MediaBlockProperties useHooks={useHooks} />
      </div>
    );
  },
  {
    Skeleton: () => (
      <DescriptionContainer className="w-full px-4 py-6 md:px-10 md:py-12">
        <PaywallCustomization.Detailed.Skeleton />
        <PaywallCustomization.Detailed.Cover.Skeleton />
        <div className="flex flex-col gap-y-5 w-full md:w-[540px] items-center">
          <div className="w-full">
            <PriceSelectorLine.Skeleton />
          </div>
          <ConfirmAndDeclineButton.Skeleton />
        </div>
      </DescriptionContainer>
    ),
  },
);
